import { c as _c } from "react/compiler-runtime";
import { FormInput, InputProps, copyTextToClipboard, useTranslation as useUiTranslation } from '@systemeio/ui';
import { MEDIA_AT_SIGN } from 'modules/stores/store/content/profile/utils/get-social-link-label';
import React, { FC } from 'react';
import { LinkIcon } from '@systemeio/ui/icons';
interface FormInputMediaProps extends Omit<InputProps, 'value' | 'onChange' | 'addonAfter'> {
  value?: string;
  onChange: (value: string) => void;
  withCopyButton?: boolean;
}
const FormInputMedia: FC<FormInputMediaProps> = t0 => {
  const $ = _c(20);
  let addonBefore;
  let onChange;
  let rest;
  let t1;
  let withCopyButton;
  if ($[0] !== t0) {
    ({
      onChange,
      value: t1,
      addonBefore,
      withCopyButton,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = addonBefore;
    $[2] = onChange;
    $[3] = rest;
    $[4] = t1;
    $[5] = withCopyButton;
  } else {
    addonBefore = $[1];
    onChange = $[2];
    rest = $[3];
    t1 = $[4];
    withCopyButton = $[5];
  }
  const value = t1 === undefined ? "" : t1;
  const {
    t: tUi
  } = useUiTranslation();
  let t2;
  if ($[6] !== value) {
    t2 = value.replace(MEDIA_AT_SIGN, "");
    $[6] = value;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const sanitizedValue = t2;
  let t3;
  if ($[8] !== onChange) {
    t3 = t4 => {
      const {
        target: t5
      } = t4;
      const {
        value: value_0
      } = t5;
      if (!value_0) {
        return onChange("");
      }
      if (value_0 === MEDIA_AT_SIGN) {
        return onChange("");
      }
      onChange(value_0.replace(MEDIA_AT_SIGN, ""));
    };
    $[8] = onChange;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const onChangeMedia = t3;
  const t4 = addonBefore || MEDIA_AT_SIGN;
  let t5;
  if ($[10] !== tUi || $[11] !== value || $[12] !== withCopyButton) {
    t5 = withCopyButton && <button type="button" onClick={async e => {
      e.preventDefault();
      await copyTextToClipboard(value, tUi);
    }} className="bg-brand-primary hover:bg-brand-primary-hover ring-brand-primary flex h-full items-center justify-center rounded-r-lg px-2 py-2.5 ring-offset-1 focus:outline-hidden focus-visible:ring-2 sm:px-4"><LinkIcon className="fill-background-secondary h-[15px] w-[15px] sm:h-[20px] sm:w-[20px]" /></button>;
    $[10] = tUi;
    $[11] = value;
    $[12] = withCopyButton;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== onChangeMedia || $[15] !== rest || $[16] !== sanitizedValue || $[17] !== t4 || $[18] !== t5) {
    t6 = <FormInput type="url" addonBefore={t4} value={sanitizedValue} onChange={onChangeMedia} addonAfterClassName="p-0 sm:p-0 lg:p-0 border-0" addonAfter={t5} {...rest} />;
    $[14] = onChangeMedia;
    $[15] = rest;
    $[16] = sanitizedValue;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
};
export default FormInputMedia;